import { format } from 'url';

export default function getQuickstartUrl(
  { quickstartId, platformId, versionId, articleId, locale } = {},
  isFramedMode,
  isSingleQuickstartMode
) {
  const pathname = [
    `/docs${locale !== undefined && locale !== 'en-us' ? '/' + locale : ''}`,
    ...(quickstartId ? ['quickstart', quickstartId] : ['quickstarts']),
    platformId,
    versionId,
    articleId,
  ]
    .filter(Boolean)
    .join('/');

  const query = Object.assign({}, isFramedMode ? { framed: 1 } : {}, isSingleQuickstartMode ? { sq: 1 } : {});

  return format({ pathname, query });
}
